export const faqItems = [
    {
        question: 'Tour book karne ka process kya hai?',
        answer:
            'Aap WhatsApp ya Contact form se apna preferred package bhej dein. Team availability, dates, aur final plan confirm karke aapko booking confirmation share karti hai.'
    },
    {
        question: 'Kitna advance payment required hota hai?',
        answer:
            'Booking lock karne ke liye advance payment required hoti hai. Exact amount package type, season, aur hotel category ke mutabiq share ki jati hai.'
    },
    {
        question: 'Package me kya include aur exclude hota hai?',
        answer:
            'Har tour page par Included/Excluded section diya gaya hai. Aam tor par transport, hotel, aur selected meals include hote hain, jabke personal shopping aur insurance exclude hota hai.'
    },
    {
        question: 'Pickup kahan se hoti hai?',
        answer:
            'Pickup location package par depend karti hai. Kuch tours Islamabad se, kuch Skardu ya Gilgit airport/city pickup ke sath available hain.'
    },
    {
        question: 'Agar weather ya road blockage ho jaye to kya hoga?',
        answer:
            'Northern areas me weather unpredictable hota hai. Team safety ko priority deti hai aur route adjustment, stopover change, ya revised timeline ke sath best possible alternate plan provide karti hai.'
    },
    {
        question: 'Cancellation aur refund policy kya hai?',
        answer:
            'Cancellation terms booking stage aur vendor commitments par depend karti hain. Final policy booking confirmation ke waqt clear share ki jati hai.'
    },
    {
        question: 'Kya honeymoon aur family-friendly packages available hain?',
        answer:
            'Ji haan. Hum honeymoon special, family tours, group departures, aur custom itineraries provide karte hain.'
    },
    {
        question: 'Kya guide aur safety support milta hai?',
        answer:
            'Selected packages me professional guide support aur basic first-aid assistance included hoti hai. Detailed support level package page par mention hota hai.'
    },
    {
        question: 'By-air tours ke liye flight delay ka kya plan hota hai?',
        answer:
            'By-air packages me schedule flights ke mutabiq adjust kiya jata hai. Delay ki surat me pickup/drop aur day plan ko real-time update kiya jata hai.'
    },
    {
        question: 'Kya hum apna custom tour plan banwa sakte hain?',
        answer:
            'Bilkul. Aap apni dates, budget, group size, aur preferred destinations share karein; hum us basis par customized itinerary design kar dete hain.'
    }
];